import React from 'react';
import Sidebar from '../components/Sidebar';
import DashboardNavbar from '../components/DashboardNavbar';
import CurrencyTable from '../components/CurrencyTable';

const Currencies = () => {
  return (
    <div className="d-flex entire-bg-color">
      <Sidebar />

      <div className="flex-grow-1">
        <DashboardNavbar />
        <div style={{ marginTop: '70px' }}></div>

        <CurrencyTable />
      </div>
    </div>
  );
};

export default Currencies;
